import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApplicantService } from '../applicant-service/applicant.service';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-submit-iterative-application-part',
  templateUrl: './submit-iterative-application-part.component.html',
  styleUrls: ['./submit-iterative-application-part.component.scss']
})
export class SubmitIterativeApplicationPartComponent implements OnInit, OnDestroy {
  @ViewChild('thankYouModal')
  thankYouModal: ModalDirective;

  subscription = new Subscription();
  applicantId: string;
  identifier: string;
  jobId: number;
  partId: number;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private applicantService: ApplicantService) { }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.subscription.add(this.route.parent.params.subscribe((params: Params) => {
      this.identifier = params['identifier'];
      this.jobId = params['jobId'];
      this.applicantId = params['applicantId'];

      this.subscription.add(this.route.params.subscribe((params2: Params) => {
        this.partId = params2['partId'];
        this.save();
      }));
    }));
  }

  save() {
    this.subscription.add(
      this.applicantService.submitIterativeApplicationPart(+localStorage.getItem('applicationId'), this.partId)
      .subscribe(
        data => {
          this.thankYouModal.show();
        },
        error => {
        }));
  }

  goToJobsPage() {
    this.router.navigate([
      location.pathname.split('/')[1]
    ]);
  }
}
